import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";

const PageTransition = ({ children }) => {
  const location = useLocation();
  const [show, setShow] = useState(false);
  const [showBar, setShowBar] = useState(false);

  useEffect(() => {
    setShow(false);
    setShowBar(true);
    const t1 = requestAnimationFrame(() => {
      requestAnimationFrame(() => setShow(true));
    });
    const t2 = setTimeout(() => setShowBar(false), 650);
    return () => { cancelAnimationFrame(t1); clearTimeout(t2); };
  }, [location.pathname]);

  return (
    <>
      {showBar && <div className="page-load-bar" key={location.pathname} />}
      <div
        style={{
          opacity: show ? 1 : 0,
          transform: show ? 'translateY(0)' : 'translateY(18px)',
          transition: 'opacity 0.5s cubic-bezier(0.4,0,0.2,1), transform 0.5s cubic-bezier(0.4,0,0.2,1)',
        }}
      >
        {children}
      </div>
    </>
  );
};

export default PageTransition;
